import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/clients")({
  component: ClientsLayout,
});

function ClientsLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "clients", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
